/**
 * Color a string red for terminal output.
 * @param str - The string to color
 */
const red = (str: string) => `\x1b[31m${str}\x1b[0m`

/**
 * Log a warning for client-only code which is used in a server environment.
 * @param context - The context or feature that is not available in the server environment.
 */
export const warnServerEnvironment = (context: string) => {
  if (process.env.NEXT_PUBLIC_ENV === 'prd') return

  console.warn(
    red(
      `Warning: ${context} is not available in the server environment. This may lead to unexpected behavior.`
    )
  )
}
